import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import BaseAnalyticsBanner from '@/components/v2/BaseAnalyticsBanner.vue';
import BaseAnalyticsBannerContent from '@/components/v2/BaseAnalyticsBannerContent.vue';
import mallStoresTotalSalesQuery from '@/plugins/graphql/queries/v2/store_management/most-store-total-sales.gql';
import RouteParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PerformanceListCountMixin from '@/helpers/vue_mixins/PerformanceListCountMixin';
import Avatar from '@/components/avatar/Index.vue';
let MostVisitedStores = class MostVisitedStores extends mixins(RouteParamsAppMixin, PerformanceListCountMixin) {
    constructor() {
        super(...arguments);
        this.section = `Most Total Sales`;
        this.customersPath = {
            name: 'ecommerce-latest-customers',
        };
    }
    get showPagination() {
        return false;
        // For the meantime for Phase 1 no `Show More Page`
        // return this.mallStoresTotalSales.length >= 5;
    }
};
MostVisitedStores = __decorate([
    Component({
        components: {
            Avatar,
            BaseAnalyticsBanner,
            BaseAnalyticsBannerContent,
        },
        apollo: {
            mallStoresTotalSales: {
                query: mallStoresTotalSalesQuery,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
            },
        },
    })
], MostVisitedStores);
export default MostVisitedStores;
